import SecureImage from 'components/SecuredImage';
import React from 'react';

interface HtmlRendererProps {
    htmlString: string;
}

const HtmlRenderer: React.FC<HtmlRendererProps> = ({ htmlString }) => {
    const parseHtml = (html: string): React.ReactNode => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const getAttributes = (el: HTMLElement) => {
            const attrs: { [key: string]: any } = {};
            for (let i = 0; i < el.attributes.length; i++) {
                const attr = el.attributes[i];

                if (attr.name === 'style') {
                    const styleObj: { [key: string]: string } = {};
                    attr.value.split(';').forEach((rule) => {
                        const [key, value] = rule.split(':');
                        if (key && value) {
                            const jsKey = key
                                .trim()
                                .replace(/-([a-z])/g, (_match, char) => char.toUpperCase());
                            styleObj[jsKey] = value.trim();
                        }
                    });
                    attrs.style = styleObj;
                } else {
                    attrs[attr.name] = attr.value;
                }
            }
            return attrs;
        };

        const convertNode = (node: ChildNode): React.ReactNode => {
            if (node.nodeType === Node.TEXT_NODE) {
                return node.textContent;
            }

            if (node.nodeType === Node.ELEMENT_NODE) {
                const element = node as HTMLElement;

                if (element.tagName.toLowerCase() === 'img') {
                    return (
                        <SecureImage
                            src={element.getAttribute('src') || ''}
                            alt={element.getAttribute('alt') || ''}
                            width={element.getAttribute('width') || undefined}
                            height={element.getAttribute('height') || undefined}
                        />
                    );
                }

                const children = Array.from(element.childNodes).map((child) => convertNode(child));

                return React.createElement(
                    element.tagName.toLowerCase(),
                    { key: Math.random(), ...getAttributes(element) },
                    ...children
                );
            }

            return <></>;
        };

        return Array.from(doc.body.childNodes).map((node) => convertNode(node));
    };
    return <>{parseHtml(htmlString)}</>;
};

export default HtmlRenderer;
